import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields } from "remult";
import { VehicleEntityConfig } from "./config";
import { VehicleFilters } from "./filters";
import { VehicleMethods } from "./methods";

@HyperEntity("vehicle", VehicleEntityConfig)
export class Vehicle extends extender(VehicleFilters, VehicleMethods) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Fields.string()
  name = "";

  @Fields.number()
  order = 0;

  @Fields.string()
  description = "";

  @Fields.string({ dbName: "image_id" })
  imageId = "";

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
